export default "__VITE_ASSET__Z1IWLJ9U__"